import React, { useContext, useState } from "react";
import Style from "./index.module.scss";
import WeekSelectPure from "../../../../../components/Public/WeekSelectPure";
import { CourseContext } from "../../../Store";
import NavBar from "../../Components/NavBar";
import classNames from "classnames";
import useRequest from "../../../../../Utils/useRequest";
import { GroupType, myFixGroup, myRandomGroup } from "../../../../../API/teams";
import { Empty, Input, Spin } from "antd";
import useBatchPicker from "../../../../main/utils/useBatchPicker";
import useDeviceType from "../../../../../Utils/useDeviceType";
import MyTeamTable from "./Components/MyTeamTable";
import TeamHeader from "../../../components/TeamLayout/components/TeamHeader";
import lodash from "lodash-es";

const Index = () => {
    const [active, setActive] = useState<GroupType>(GroupType.Static);
    const { isPC } = useDeviceType();
    const { course, basename } = useContext(CourseContext);
    const { batch } = useBatchPicker();
    const { weekTimeId } = course;
    const [wid, setWid] = useState(weekTimeId);
    const [keyword, setKeyword] = useState("");
    const getParams = {
        courseNo: course.courseNo,
        courseSeq: course.courseSeq,
        batchNo: batch,
        keyword
    };
    const [data, { loading }] = useRequest(
        () => {
            if (active === GroupType.Static) {
                return myFixGroup(getParams);
            } else {
                return myRandomGroup(getParams);
            }
        },
        {},
        [keyword, wid, active]
    );

    return (
        <>
            <div className={Style.root}>
                {isPC && <TeamHeader />}

                {isPC && (
                    <div className={Style.bg}>
                        <WeekSelectPure
                            onChange={setWid}
                            weekTimeId={wid}
                            className={Style.week}
                        />
                    </div>
                )}

                <NavBar>
                    <div>
                        <span
                            onClick={() => setActive(GroupType.Static)}
                            className={classNames(
                                Style.link,
                                Style.links,
                                active === GroupType.Static && Style.current
                            )}>
                            固定小组
                        </span>
                        <span
                            onClick={() => setActive(GroupType.Random)}
                            className={classNames(
                                Style.link,
                                Style.links,
                                active === GroupType.Random && Style.current
                            )}>
                            随机小组
                        </span>
                    </div>
                </NavBar>
                <Spin spinning={loading}>
                    <div className={Style.staticContent}>
                        <div className={Style.staticHeader}>
                            <Input.Search
                                placeholder="请输入学生姓名"
                                onSearch={setKeyword}
                                style={{ width: 200 }}
                            />
                        </div>
                        <div className={Style.staticMain}>
                            {data && data?.length > 0 && (
                                <MyTeamTable data={data} />
                            )}
                            {lodash.isEmpty(data) && <Empty />}
                        </div>
                    </div>
                </Spin>
            </div>
        </>
    );
};

export default Index;
